import { CORE_VALUES } from "@/data/products";

export default function MissionVisionValues() {
  return (
    <section className="py-24 lg:py-32 bg-background" data-testid="mission-values-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-6 mb-16">
          <div className="bg-neutral-950 text-white rounded-3xl p-10 lg:p-12 relative overflow-hidden">
            <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-gold-400/20 blur-3xl" />
            <div className="relative">
              <div className="eyebrow text-gold-400 mb-4">Mission</div>
              <p className="font-display text-2xl lg:text-3xl leading-tight">
                To produce world-class beverages that deliver <span className="gold-gradient-text">quality, freshness and value</span> &mdash; building trusted brands enjoyed across the UK, Africa and the world.
              </p>
            </div>
          </div>
          <div className="bg-gold-400 text-neutral-950 rounded-3xl p-10 lg:p-12 relative overflow-hidden">
            <div className="absolute -bottom-20 -left-20 w-64 h-64 rounded-full bg-neutral-950/10 blur-3xl" />
            <div className="relative">
              <div className="text-xs uppercase tracking-[0.24em] font-bold mb-4 text-neutral-950/80">Vision</div>
              <p className="font-display text-2xl lg:text-3xl leading-tight">
                To become one of the world&rsquo;s most respected beverage companies — recognised for innovation, quality and responsible growth.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mb-12 space-y-4">
          <div className="eyebrow">Core Values</div>
          <h2 className="font-display font-bold text-4xl lg:text-5xl tracking-tighter">Eight principles. One SBC.</h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {CORE_VALUES.map((v, i) => (
            <div key={v.title} className="group p-6 rounded-2xl border border-border hover:border-gold-400 transition-colors bg-background hover:-translate-y-1 duration-300">
              <div className="text-[10px] uppercase tracking-widest text-gold-500 font-bold">0{i + 1}</div>
              <div className="font-display font-bold text-lg mt-3">{v.title}</div>
              <p className="text-xs text-muted-foreground mt-2 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
